export const FETCH_SETTLEMENT_LOGS = 'FETCH_SETTLEMENT_LOGS';
export const FETCH_SETTLEMENT_DETAILS_LOGS = 'FETCH_SETTLEMENT_DETAILS_LOGS';
